import axios from 'axios';
import recordDescriptorProcessing from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

function getStep(stepId, options = {}) {
  const url = process.env.REACT_APP_API + '/completion_criteria/' + stepId + '?current_company=' + localStorage.current_company_id
    + (options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
  return axios({
    url,
    timeout: 60000,
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Content-Type': 'application/json',
      'Authorization': 'Token token=' + localStorage.token,
    },
  }).then(response => {
    return response.data;
  }).catch(error => {
    return serviceUtil.resultForError(error);
  });
}

function getEventCounts(stepId) {
  const url = process.env.REACT_APP_API + '/completion_criteria/' + stepId + '/event_histories/counts?current_company=' + localStorage.current_company_id;
  return axios({
    url,
    timeout: 60000,
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Content-Type': 'application/json',
      'Authorization': 'Token token=' + localStorage.token,
    },
  }).then(response => {
    return response.data;
  }).catch(error => {
    return serviceUtil.resultForError(error);
  });
}

export default {
  getStep,
  getEventCounts,
};



// WEBPACK FOOTER //
// ./src/services/completionStepService.js